import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useAuth } from '../../../context/AuthContext';
import { getCommissionSummary } from '../../../services/commissionService';
import ManageCustomerTab from './ManageCustomerTab';
import ManageReferralTab from './ManageReferralTab';
import ManageSettlementTab from './ManageSettlementTab';

const TABS = ['고객', '추천', '정산'];

const RecommendManage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { userData } = useAuth();
  const [summary, setSummary] = useState({ total: 0, withdrawable: 0 });

  useEffect(() => {
    if (!userData?.uid) return;
    getCommissionSummary(userData.uid).then(setSummary).catch(() => {});
  }, [userData?.uid]);

  return (
    <Wrap>
      {/* 파란 pill 수익 카드 */}
      <RewardCard>
        <RewardLabel>출금 가능 수익</RewardLabel>
        <RewardAmount>{summary.withdrawable.toLocaleString()}원</RewardAmount>
        <RewardSub>총 수수료 {summary.total.toLocaleString()}원</RewardSub>
      </RewardCard>

      {/* 밑줄 탭 */}
      <TabRow>
        {TABS.map((t, i) => (
          <TabBtn key={t} $active={activeTab === i} onClick={() => setActiveTab(i)}>
            {t}
          </TabBtn>
        ))}
      </TabRow>

      {/* 탭 컨텐츠 */}
      <Content>
        {activeTab === 0 && <ManageCustomerTab />}
        {activeTab === 1 && <ManageReferralTab />}
        {activeTab === 2 && <ManageSettlementTab />}
      </Content>
    </Wrap>
  );
};

export default RecommendManage;

// ───── 스타일 ─────

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
`;

const RewardCard = styled.div`
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 16px;
  padding: 20px;
  text-align: center;
  color: #fff;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

const RewardLabel = styled.p`
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 4px;
`;

const RewardAmount = styled.p`
  font-size: 32px;
  font-weight: ${({ theme }) => theme.fontWeight.extrabold};
  color: #fff;
  line-height: 1.1;
  margin-bottom: 6px;
`;

const RewardSub = styled.p`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.75);
`;

const TabRow = styled.div`
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight};
`;

const TabBtn = styled.button`
  flex: 1;
  padding: 14px 0;
  font-size: ${({ theme }) => theme.fontSize.base};
  font-weight: ${({ $active, theme }) => $active ? theme.fontWeight.bold : theme.fontWeight.medium};
  color: ${({ $active, theme }) => $active ? theme.colors.primary : theme.colors.textSecondary};
  background: none;
  border: none;
  border-bottom: 2px solid ${({ $active, theme }) => $active ? theme.colors.primary : 'transparent'};
  margin-bottom: -1px;
  cursor: pointer;
  transition: all 0.15s;
`;

const Content = styled.div`
  padding-top: ${({ theme }) => theme.spacing.lg};
  padding-bottom: ${({ theme }) => theme.spacing.lg};
`;
